import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { first } from 'rxjs/operators';
import { ReviewService, Review } from '@app/_components/review';
import { AlertService, AuthenticationService, DataCacheService } from '@app/_services';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItem, LazyLoadEvent, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { Locations, ListingStatus } from '@app/_helpers/constants';
import { DialogService } from 'primeng/dynamicdialog';
import { ReviewComponent } from '../review/review.component';
import { VRBOReviewDetailComponent } from '@app/_components/vrbo/components/vrbo-review-detail/vrbo-review-detail.component';


@Component({
    selector: 'app-review-list',
    templateUrl: './review-list.component.html',
    styleUrls: ['./review-list.component.css'],
    providers: [DialogService],
    standalone: false
})
export class ReviewListComponent implements OnInit {

	@ViewChild('pt') table: Table;

	// 0 or 1 of the following Ids may be passed.  If passed, filter on Id.
	@Input() shortTermRentalId: any;
	@Input() activityId: any;
	@Input() propertyCode: any;
	@Input() reservationId: any;

	datasource: Review[];
	review: Review;
	reviews: Review[] = [];
	columns: any[];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	userStatusOptions: SelectItem[];
	showPaginator = false;

	statuses = [
		{ name: 'Draft', value: 1 },
		{ name: 'New', value: 2 },
		{ name: 'Approved', value: 3 },
		{ name: 'Rejected', value: 4 },
	];

	reviewSources = [
		{ name: 'VRBO', value: 'VRBO' },
		{ name: 'KBM', value: 'KBM' },
	];
	msgIdList: any[]=[];
	yelpMsgIdList: any[]=[];



	// Query param filters (applied from URL, e.g. ?rating=1&reviewDate=2026-04-07)
	initialRatingFilter: string = null;
	initialDateFilter: string = null;

	constructor(
		private authenticationService: AuthenticationService,
		private reviewService: ReviewService,
		private dataCacheService: DataCacheService,
		private alertService: AlertService,
		private messageService: MessageService,
		private router: Router,
		private route: ActivatedRoute,
		public dialogService: DialogService
	) { }


	ngOnInit() {
		const params = this.route.snapshot.queryParams;
		if (params['rating']) {
			this.initialRatingFilter = params['rating'];
		}
		if (params['reviewDate']) {
			this.initialDateFilter = params['reviewDate'];
		}
		this.getSentPublicReviewRequests();
		this.getSentYelpReviewRequests();
	}

	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);



			/*
			*
			* Default Sort
			*/
			// Inject URL query param filters — must run on every loadLazy call (including the first)
			// to prevent a race condition where the initial unfiltered API response overwrites the filtered one
			if (this.initialRatingFilter) {
				Object.assign(event.filters, { 'rating': { 'value': parseInt(this.initialRatingFilter, 10), 'matchMode': 'equals' } });
			}
			if (this.initialDateFilter) {
				Object.assign(event.filters, { 'reviewDate': { 'value': this.initialDateFilter, 'matchMode': 'equals' } });
			}

			// https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (!event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'reviewDate', order: -1 });
			}

			if(this.activityId)
			{
				// show only activities that are assigned to this activityId
				let activityIdFilter = { 'activityId': { 'value': this.activityId, 'matchMode': 'in' } };
				Object.assign(event.filters, activityIdFilter);
			}

			if(this.shortTermRentalId)
			{
				// show only shortTermRentals that are assigned to this shortTermRentalIdFilter
				let shortTermRentalIdFilter = { 'shortTermRentalVO.shortTermRentalId': { 'value': this.shortTermRentalId, 'matchMode': 'in' } };
				Object.assign(event.filters, shortTermRentalIdFilter);
			}

			if (this.reservationId) {
				// show only reservations that are assigned to this reservationId
				let reservationIdFilter = { 'reservationId': { 'value': this.reservationId, 'matchMode': 'in' } };
				Object.assign(event.filters, reservationIdFilter);
			}

			if(this.propertyCode)
			{
				// show only shortTermRentals that are assigned to this propertyCodeFilter
				let propertyCodeFilter = { 'shortTermRentalVO.propertyCode': { 'value': this.propertyCode, 'matchMode': 'in' } };
				Object.assign(event.filters, propertyCodeFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.reviewService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					res => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.reviews = res.data.reviews;
						this.reviews.forEach(review => {
							if(review.responseDesc != undefined && review.responseDesc != null && review.responseDesc != ""){
								review.responseDescFlag = true;
							}else{
								review.responseDescFlag = false;
							}
						  });
						if(this.reviews.length < event.rows){
							this.showPaginator = false;
						}else{
							this.showPaginator = true;
						}
						console.log(JSON.stringify(res.page))
					},
					err => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.reviews = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}
	onRowSelect(event) {
		const reviewData = event.data;

		// Open VRBO detail dialog for VRBO-sourced reviews
		if (reviewData.reviewSource === 'VRBO') {
			const ref = this.dialogService.open(VRBOReviewDetailComponent, {
				data: {
					review: reviewData,
					shortTermRentalId: reviewData.shortTermRentalId
				},
				header: 'VRBO Review Details',
				width: '80%',
				closeOnEscape: true
			});

			ref.onClose.subscribe((result: any) => {
				if (result) {
					if (result.action === 'RESPONDED' || result.action === 'UPDATED') {
						this.loadLazy(this.lazyLoadEvent);
					}
				}
			});
			return;
		}

		// Default: open KBM review dialog
		const ref = this.dialogService.open(ReviewComponent, {
			data: {
				review: reviewData,
			},
			header: 'Review',
			width: '80%',
			closeOnEscape: true
		});

		ref.onClose.subscribe((review: Review) => {
			if (review) {
				if (review.action === 'UPDATED') {
					var foundIndex = this.reviews.findIndex(x => x.reviewId == review.reviewId);
					this.reviews[foundIndex] = review;
				}

				if (review.action === 'DELETED') {
					var foundIndex = this.reviews.findIndex(x => x.reviewId == review.reviewId);
					this.reviews.splice(foundIndex, 1);
					this.messageService.add({ severity: 'info', summary: 'Success', detail: 'Review ' + review.reviewId + ' Deleted.', sticky: false });
				}
			}
		});
	}



	onNewReviewButtonClick() {
		const ref = this.dialogService.open(ReviewComponent, {
			data: {
				reservationId: this.reservationId
			},
			header: 'Review',
			width: '80%',
			closeOnEscape: true
		});

		ref.onClose.subscribe((review: Review) => {
			if (review) {

				if (review.action === 'ADDED') {
					this.reviews.unshift(review);
				}
			}
		});
	}
	get Statuses() {
		return this.statuses;
	}

	getStatusName(review: any) {
		const status = this.statuses.find(e => e.value === review.status);
		return status.name;
	}

	reloadPage() {
		window.location.reload();
	}

	sendPublicReviewRequestEmail(review: any){
		try {
			const data = {
				"guestName": review.firstName +" "+review.lastName,
				"propertyCode": review.propertyCode,
				"message": review.reviewDesc,
				"contactPreference": "email",
				"email": review.emailAddress,
				"reviewId": review.reviewId,
				"reservationId": review.reservationId
			}

			this.reviewService.sendPublicReviewRequestEmailById(review.reviewId)
				.subscribe(
					(res: any) => {
						this.getSentPublicReviewRequests();
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Review request sent successfully.', sticky: false });
					},
					(err: any) => {
						console.log('job-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	getSentPublicReviewRequests(){
		try {
			this.reviewService.getReviewRequestsTopicIds()
				.subscribe(
					(res: any) => {
						this.msgIdList = res.data.msgs;
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
					},
					(err: any) => {
						console.log('job-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	sendYelpReviewRequestEmail(review: any){
		try {
			this.reviewService.sendYelpReviewRequestEmailById(review.reviewId)
				.subscribe(
					(res: any) => {
						this.getSentYelpReviewRequests();
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Yelp review request sent successfully.', sticky: false });
					},
					(err: any) => {
						console.log('job-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	getSentYelpReviewRequests(){
		try {
			this.reviewService.getYelpReviewRequestsTopicIds()
				.subscribe(
					(res: any) => {
						this.yelpMsgIdList = res.data.msgs;
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
					},
					(err: any) => {
						console.log('job-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });

		} catch (error) {
			this.alertService.error(error);
		}
	}
}
